import axios from "axios";
const configs = require("./configs");

export default async function postHelper(url, body) {
  const { xApiKey } = await configs;

  const req = await axios.post(url, body, {
    headers: {
      "x-api-key": xApiKey,
      "Content-Type": "application/json",
    },
  });
  return req.data;
}
